// extracted by mini-css-extract-plugin
export default {"wrapper":"style-module--wrapper--fa541","videoSwap":"style-module--videoSwap--858a9","imageSwap":"style-module--imageSwap--b3cb3"};